import moment from 'moment';

import templateUrl from './edit-work-order-modal.component.html';

export const EditWorkOrderModalComponent = {
    controller: EditWorkOrderModalController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    }
};

function EditWorkOrderModalController(workOrderService, utilityService) {
    'ngInject';
    const vm = this;
    vm.$onInit = onInit;
    vm.onSave = onSave;

    vm.resolve;
    vm.close;
    vm.dismiss;

    function onInit() {
        vm.workOrder = vm.resolve.workOrder || {};
    }

    function convertCustomDetailsToDictonary(details) {
        return details.reduce(function (r, e) {
            r[e.Key] = e.Value;
            return r;
        }, {});
    }

    function getCombinedCustomDetails(productOrderCustomDetails, workOrderCustomDetails) {
        //Init if undefined just to be on safe side
        productOrderCustomDetails = productOrderCustomDetails || [];
        workOrderCustomDetails = workOrderCustomDetails || [];
        const newProductOrderCustomDetails = workOrderCustomDetails.filter(function (detail) {
            return !productOrderCustomDetails.some(p => detail.Key === p.Key);
        });
        return productOrderCustomDetails.concat(newProductOrderCustomDetails);
    }

    function appendAccountNumberToCustomDetails(workOrder) {
        if (workOrder.AccountNumber) {
            workOrder.ProductOrders = workOrder.ProductOrders || [];
            workOrder.ProductOrders.forEach(function (productOrder) {
                productOrder.CustomDetails = productOrder.CustomDetails || [];
                productOrder.CustomDetails.push({ Key: 'ACCOUNT_NUMBER', Value: workOrder.AccountNumber })

            });
        }
    }

    function onSave() {
        //Append account number to each product orrder's custom detail if it is defined in work order level
        appendAccountNumberToCustomDetails(vm.workOrder);
        const productOrders = vm.workOrder.ProductOrders.map(function (productOrder) {
            const customDetails = getCombinedCustomDetails(productOrder.CustomDetails, vm.workOrder.CustomDetails);
            return {
                ProductID: productOrder.ProductID,
                ProductLineID: productOrder.ProductLineID,
                Quantity: productOrder.Quantity,
                StatusID: productOrder.ProductOrderStatusID,
                IsConfirmed: productOrder.IsConfirmed,
                CustomDetails: convertCustomDetailsToDictonary(customDetails),
                // Effective date is time-sensitive, so use the start of day UTC for representing no time component.
                EffectiveDate: moment(productOrder.EffectiveDate).utc().startOf("day").toDate()
            };
        });
        // Add a "Booked" status to each work order to ensure it appears in the history correctly.
        //TODO: This logic needs to be fleshed out to allow history editing and adding multiple
        // statuses at once.
        productOrders.push(...vm.workOrder.ProductOrders.filter(productOrder =>
            // Don't append if the Booked status was already selected in the product order list.
            productOrder.ProductOrderStatusID !== vm.workOrder.BookedStatus.ProductOrderStatusID)
            .map(function (productOrder) {
                const customDetails = getCombinedCustomDetails(productOrder.CustomDetails, vm.workOrder.CustomDetails);
                return {
                    ProductID: productOrder.ProductID,
                    ProductLineID: productOrder.ProductLineID,
                    Quantity: productOrder.Quantity,
                    StatusID: vm.workOrder.BookedStatus.ProductOrderStatusID,
                    IsConfirmed: productOrder.IsConfirmed,
                    CustomDetails: convertCustomDetailsToDictonary(customDetails),
                    // Effective date is time-sensitive, so use the start of day UTC for representing no time component.
                    EffectiveDate: moment(vm.workOrder.OrderDate).utc().startOf("day").toDate()
                };
            }));

        const request = {
            DivisionID: vm.workOrder.DivisionID,
            DivisionWorkOrderID: vm.workOrder.DivisionWorkOrderID,
            LeadID: vm.workOrder.LeadID,
            Employment: vm.workOrder.Employment,
            OrderDate: kendo.format("{0:yyyy-MM-dd}", vm.workOrder.OrderDate),
            // report date doesn't exist at the work order level
            ReportDate: kendo.format("{0:yyyy-MM-dd}", vm.workOrder.OrderDate),
            ProductOrders: productOrders
        };

        const workOrderSaved = workOrderService.createWorkOrder(request)
            .then(function (response) {
                vm.workOrder.WorkOrderID = response.WorkOrderID;
                alert("Success");
                vm.close({ $value: vm.workOrder });
            });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(workOrderSaved, "Save failed"));
    }
}
